module.exports = __webpack_public_path__ + "img/ico-like02.fee11212.svg";